import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/gburesult"

const serviceName = "GbuResult-Service: ";

export default class GbuResultService {
    static async  readAllForFacilityFromAPI(id, successF, errorF) {
        await WrapperService.get(API_URL + "/facility/" + id, null, serviceName, successF, errorF);
    }

    static async updateGbuAndGenerateReport(gbuResultId, protectionsJson, successF, errorF) {
        await WrapperService.put(API_URL + "/report/" + gbuResultId, protectionsJson, serviceName, successF, errorF);
    }
    static async generateSupportReport(gbuResultId, allProtectionsJson, successF, errorF) {
        await WrapperService.put(API_URL + "/support-report/" + gbuResultId, allProtectionsJson, serviceName, successF, errorF);
    }
    static async  readFromAPI(id, successF, errorF) {
        await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
    }
    static async readMultipleFromAPI(idArray, successF, errorF) {
        await WrapperService.post(API_URL + "/multi-get", idArray, serviceName, successF, errorF);
    }
}